import { Controller } from 'react-hook-form'
import { AiOutlineMinus } from 'react-icons/ai'
import classes from './DateSection.module.css'
import Input from '../../../UI/Form/Input'
import CustomDatepicker from '../../../UI/Form/CustomDatepicker'
import Field from '../../../UI/Field/Field'
import CustomButton from '../../../UI/CustomButton/CustomButton'

const DateSection = (props) => {
    const { index, control, onRemove } = props

    return (
        <div className={classes.main}>
            <div className={classes.header}>
                <h4>Day {index + 1}</h4>
                <CustomButton className={classes.removeBut} onClick={() => onRemove(index)}>
                    <AiOutlineMinus/>
                    <span>Remove</span>
                </CustomButton>
            </div>
            <Controller
                name={`dates.${index}.date`}
                control={control}
                defaultValue=""
                rules={{ required: "Required Field!" }}
                render={({
                    field: { onChange, value, name },
                    fieldState: { error }
                }) => (
                    <CustomDatepicker
                        name={name}
                        onChange={onChange}
                        value={value}
                        error={error}
                        label="Date"
                    />
                )}
            />
            <Field>
                <Controller
                    name={`dates.${index}.start`}
                    control={control}
                    defaultValue=""
                    rules={{ required: "Required Field!" }}
                    render={({
                        field: { onChange, value, name },
                        fieldState: { error }
                    }) => (
                        <Input
                            name={name}
                            onChange={onChange}
                            value={value}
                            error={error}
                            label="Start"
                            regex="time"
                        />
                    )}
                />
                <Controller
                    name={`dates.${index}.end`}
                    control={control}
                    defaultValue=""
                    rules={{ required: "Required Field!" }}
                    render={({
                        field: { onChange, value, name },
                        fieldState: { error }
                    }) => (
                        <Input
                            name={name}
                            onChange={onChange}
                            value={value}
                            error={error}
                            label="End"
                            regex="time"
                        />
                    )}
                />
            </Field>
        </div>
    )
}

export default DateSection